module.exports = {
	"no": {
		"static-pages": {
			"notFound": {
				"pageTitle": "Siden ble ikke funnet",
				"title": "Ikke funnet",
				"details": "Programmet du leter etter, ble ikke funnet. Er du sikker på at du skrev inn adressen riktig?",
				"goBack": "Gå tilbake"
			},
			"activation": {
				"pageTitle": "Sikker sone",
				"title": "Velkommen til sikker sone",
				"activate": {
					"details": "Vent litt mens vi forbereder aktiveringslenken din...",
					"ready": "Lenken din er klar, klikk på knappen for å fortsette. Merk: Denne lenken kan kun brukes én gang!",
					"go": "Aktiver konto"
				},
				"passwordReset": {
					"details": "Bare vent litt, vi gjør klar en passordgjennoppretting...",
					"ready": "Lenken din er klar, klikk på knappen for å fortsette. Merk: Denne lenken kan kun brukes én gang! ",
					"go": "Sett opp passord på nytt"
				},
				"error": {
					"details": "Det virker som noe er galt med koblingen din. Vennligst prøv igjen, eller kontakt støttetjenesten, og refererer til koden."
				}
			},
			"privacy-policy": {
				"pageTitle": "Personvernpolicy via Merchant Policy"
			},
			"terms-and-conditions": {
				"pageTitle": "Merchant Portal-avtale"
			},
			"Support": {
				"pageTitle": "Support",
				"topic": {
					"orders": "Ordrer",
					"settlements": "Oppgjør",
					"agreements": "Avtaler",
					"technical_issues": "Tekniske problemer",
					"others": "Andre"
				},
				"TicketList": {
					"title": "Supportforespørsler",
					"pageDescription": "Her kan du se statusen til supportforespørslene dine",
					"status": {
						"open": "Åpen",
						"pending": "Venter",
						"resolved": "Løst",
						"closed": "Lukket",
						"inProgress": "Pågående",
						"waitingForYourReply": "Venter på svar fra deg"
					},
					"TicketTable": {
						"id": "Be om #",
						"mid": "Butikk / MID",
						"subject": "Emne",
						"status": "Status",
						"updatedAt": "Siste oppdatering"
					}
				},
				"EmptyTicketList": {
					"title": "Du har ingen åpne forespørsler"
				},
				"ticketDetails": {
					"sidebar": {
						"user": {
							"title": "Bruker"
						},
						"details": {
							"title": "Detaljer",
							"store": "Butikk / MID",
							"createdAt": "Dato for forespørsel",
							"updatedAt": "Siste oppdatering"
						},
						"actions": {
							"close": "Lukk forespørsel",
							"reopen": "Åpne forespørsel på nytt"
						},
						"closeTicketDialog": {
							"confirm": "Bekreft",
							"title": "Lukk forespørsel",
							"description": "Du er i ferd med å lukke denne forespørselen. Du vil bare kunne åpne den i løpet av de neste 7 dagene.",
							"error": "Oisann! Noe gikk galt, prøv igjen."
						},
						"reopenTicketDialog": {
							"title": "Åpne forespørselen på nytt",
							"description": "Fortell oss mer hvorfor du trenger å åpne denne forespørselen, så vil vi snart kontakte deg.",
							"messageLabel": "Beskjed"
						}
					},
					"conversation": {
						"loadMore": "Last mer",
						"title": "Forespørsel",
						"attachments": {
							"label": "Vedlegg"
						},
						"reply": {
							"title": "Legg til svar",
							"body": {
								"label": "Legg til et svar",
								"error": null
							},
							"attachment": {
								"label": "Legg til vedlegg",
								"error": "Total filstørrelse kan ikke overstige 15 MB"
							},
							"add": "Legg til svar",
							"cancel": "Avbryt",
							"submit": {
								"label": "Send inn",
								"error": "Feil ved lagring av svar. Prøv igjen senere"
							}
						}
					}
				},
				"errorView": {
					"429": {
						"title": "Au da!",
						"message": "Noe gikk galt, prøv igjen om noen minutter. Kontakt oss for hjelp hvis problemet vedvarer.",
						"contact": "Når du kontakter support, vennligst oppgi følgende korrelasjons-ID",
						"action": "Kontakt oss"
					},
					"error": "Feil",
					"default": {
						"title": "Oi sann, noe gikk galt",
						"message": "Av en eller annen grunn fra vår side klarte vi ikke å behandle forespørselen din. Du kan prøve igjen eller komme tilbake senere.",
						"contact": "Når du kontakter support, vennligst oppgi følgende korrelasjons-ID",
						"action": "Oppdater"
					}
				}
			},
			"Marketing": {
				"pageTitle": "Markedsføringsressurser",
				"banner": {
					"title": "Velkommen til markedsføringsressurser!",
					"subtitle": "Her finner du ferdige ressurser for nettstedet ditt, e-postkampanjer og markedsføring via sosiale medier.",
					"button": "Lær mer"
				},
				"productSection": {
					"title": "Hvilket Klarna-produkt tilbyr du til kunder?"
				},
				"MarketSelector": {
					"label": "Velg marked",
					"markets": {
						"BE": "Belgia (nederlandsk)",
						"BE-FR": "Belgia (fransk)"
					}
				},
				"ChannelSelector": {
					"pageTitle": {
						"kco": "Klarna Checkout",
						"fourInstallments": "4 avdrag",
						"pin30": "Betal om 30 dager"
					}
				},
				"sourceAndPreview": {
					"helpButton": "Trenger du hjelp med å bruke dette?",
					"copyButton": "Kopier til utklippstavlen",
					"copyButtonSuccess": "Kopiert!",
					"sourceButton": "Kilde",
					"previewButton": "Forhåndsvisning"
				},
				"EmailTemplates": {
					"pageTitle": "E-postmaler",
					"title": "E-postmaler"
				},
				"EmailHeader": {
					"pageTitle": "E-postmarkedsføringsbilde",
					"title": "E-postmarkedsføringsbilde"
				},
				"Social": {
					"pageTitle": "Sosiale medier",
					"title": "Sosiale medier"
				},
				"buttonDownload": "Last ned bilde",
				"buttonCopy": "Kopier tekst",
				"buttonCopySuccess": "Kopiert!",
				"missingPreview": "Mangler forhåndsvisning",
				"productLinkText": "Få ressurser",
				"content": {
					"products": {
						"kco": {
							"title": "Klarna Checkout",
							"subtitle": "En komplett betalingsløsning med alt på ett sted."
						},
						"payNow": {
							"title": "Betal nå",
							"subtitle": "La kundene betale for kjøpet på stedet."
						},
						"threeInstallments": {
							"title": "3 avdrag",
							"subtitle": "Gi kundene frihet til å spre kostnaden rentefritt over tid."
						},
						"fourInstallments": {
							"title": "4 avdrag",
							"subtitle": "Gi kundene frihet til å spre kostnaden rentefritt over tid."
						},
						"pin14": {
							"title": "Betal om 14 dager",
							"subtitle": "Betal om 14 dager. Ingen renter eller tilleggsgebyrer."
						},
						"pin21": {
							"title": "Betal om 21 dager",
							"subtitle": "Betal om 21 dager. Ingen renter eller tilleggsgebyrer."
						},
						"pin30": {
							"title": "Betal om 30 dager",
							"subtitle": "Betal om 30 dager. Ingen renter eller tilleggsgebyrer."
						},
						"financing": {
							"title": "Finansiering",
							"subtitle": "Øk salget ditt ved å tilby kunder opptil 36 måneder å betale."
						}
					},
					"campaigns": {
						"holidays-2020": {
							"title": "Ferier 2020",
							"channels": {
								"emailHeader": {
									"title": "E-postmarkedsføringsbilde",
									"subtitle": "Få abonnentene til å se to ganger denne julen, med bilder i studiokvalitet for e-postkampanjene dine.",
									"linkText": "Vis bilder",
									"introduction": "Det er på tide å la abonnentene få vite alt om dine fantastiske juletilbud og rabatter. Last ned et bilde og legg det til i e-postkampanjen eller som topptekst for å få størst innvirkning."
								},
								"social": {
									"title": "Sosiale medier",
									"subtitle": "Driv flere kunder til butikken din i løpet av julesesongen med gratis bruk av disse bildene.",
									"linkText": "Se poster",
									"introduction": "Det er på tide å spre ordet om dine fantastiske juletilbud og rabatter! Bare last ned ressursene og last dem opp til dine sosiale medieprofiler eller planleggingsverktøyet. Husk å tagge {link} i kunngjøringene dine for å nå enda flere kunder og konverteringer."
								}
							},
							"imageAlt": {
								"holiday1": "Person i en blå, rosa og sølvfarget drakt glir på ett kne mot en mopp med en sølvsko i én hånd og smarttelefon i den andre.",
								"holiday2": "Person i burgunder satengpysj svever over en bordvifte med bena i kors og med en smarttelefon flytende i øyehøyde."
							}
						},
						"at-launch": {
							"title": "Ved lansering",
							"subtitle": "Nettopp startet reisen med oss? Bruk disse ressursene for å la nye og eksisterende kunder vite at du tilbyr Klarna.",
							"channels": {
								"email": {
									"title": "E-postmaler",
									"subtitle": "Fortell abonnentene at det er en ny måte å betale checkout.",
									"linkText": "Vis maler",
									"introduction": "Det er på tide å fortelle abonnentene dine at du har lansert Klarna! Bare kopier og lim inn malen eller innholdet på e-postplattformen din, så er du klar.",
									"codeBoxTitle": "Lanser e-post"
								},
								"social": {
									"title": "Sosiale medier",
									"subtitle": "Driv flere kunder til butikken din med disse smooothe bildene i studiokvalitet.",
									"linkText": "Se poster",
									"introduction": "Det er på tide å kunngjøre til verden at du har lansert med Klarna! Bare last ned ressursene og last dem opp til dine sosiale medieprofiler eller planleggingsverktøyet. Husk å tagge {link} i kunngjøringene dine for å nå enda flere kunder og konverteringer."
								},
								"osm": {
									"title": "Landingssider",
									"subtitle": "Vær kompatibel og informer kundene om hvordan de handler med Klarna.",
									"linkText": "Vis sider"
								}
							},
							"imageAlt": {
								"emotional": "Person med langt, krøllete hår i lilla jumpsuit som spiller en flipperspill",
								"paymentShowcase": "En hånd som holder en telefon som viser Klarna-logoen, rulleskøyter i bakgrunnen",
								"simplified": "Telefon med forsiden ned på en flippermaskin i krom til høyre, lysegul sofa til venstre",
								"device": "En telefon som viser Klarna-logoen som dingler fra det rosa rommet med lysekrone i bakgrunnen"
							}
						}
					}
				}
			}
		}
	}
};